import e,{createContext as r,useContext as t}from"react";function n(n){var u=r({}),o=n(function(){return t(u)});return function(r){return e.createElement(u.Provider,{value:r},e.createElement(o,r))}}export default n;
//# sourceMappingURL=next-dynamic-loading-props.module.js.map
